<template>
    <div>
        <Toast />

        <router-view :key="$route.path">
            <div class="card flex flex-column">
                <header class="flex justify-content-between gap-8 align-items-center px-6 pt-6">
                    <div class="mw-25">
                        <div class="breadcrumb-container flex mb-4 gap-4">
                            <span class="pi pi-home"></span>
                            <span class="pi pi-angle-right"></span>
                            <p class="text-xl">SESMT</p>
                            <span class="pi pi-angle-right"></span>
                            <p class="text-xl cursor-pointer">Plano de Ação</p>
                        </div>
                        <div>
                            <h4>{{ this.planoAcao?.customer?.name }} | {{ this.planoAcao?.unidade?.name }}</h4>
                        </div>
                    </div>
                    <Steps :readonly="false" :model="items" aria-label="Form Steps" class="flex-1" />
                </header>

                <div class="flex gap-8 mt-4 px-6">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-calendar mt-2" style="font-size: 20px"></i>
                        <p class="mt-3">
                            Data inicial:
                            {{
                                `${this.planoAcao.dataInicial?.split('-')[2]}/${this.planoAcao.dataInicial?.split('-')[1]}/${
                                    this.planoAcao.dataInicial?.split('-')[0]
                                }`
                            }}
                        </p>
                    </div>
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-calendar mt-2" style="font-size: 20px"></i>
                        <p class="mt-3">
                            Data prevista de conclusão:
                            {{
                                `${this.planoAcao.dataPrevisao?.split('-')[2]}/${this.planoAcao.dataPrevisao?.split('-')[1]}/${
                                    this.planoAcao.dataPrevisao?.split('-')[0]
                                }`
                            }}
                        </p>
                    </div>
                    <div class="flex align-items-center">
                        <p class="mt-3">Objetivo: {{ this.planoAcao.objetivoAcao }}</p>
                    </div>
                    <div class="flex align-items-center">
                        <p class="mt-3">Prioridade: {{ this.planoAcao.prioridadeCausa }}</p>
                    </div>
                    <div class="flex align-items-center">
                        <p class="mt-3">Nome da ação: {{ this.planoAcao.nomeAcao }}</p>
                    </div>
                    <div class="flex align-items-center gap-2" style="margin-left: auto">
                        <p class="mt-3">
                            Status: <span :class="`${this.planoAcao.status}`">{{ this.planoAcao.status?.replace('_', ' ') }}</span>
                        </p>
                    </div>
                </div>
                <div class="px-6 my-4">
                    <Divider />
                </div>
                <Message
                    class="mx-6 message"
                    severity="info"
                    sticky
                    :closable="false"
                    :style="{
                        color: '#252529',
                        backgroundColor: '#EDEDED'
                    }"
                    >Somente as atualizações serão impressas no documento oficial.</Message
                >

                <TabView class="mt-2 px-6">
                    <TabPanel header="Atualizações">
                        <Atualizacoes @getData="getData" :lista="listaAtualizacoes" />
                    </TabPanel>
                    <TabPanel header="Comentários">
                        <Comentarios @getData="getData" :lista="listaComentarios" />
                    </TabPanel>
                </TabView>
                <div class="mt-8 w-100 flex align-items-center justify-content-end">
                    <Button label="Voltar" @click="$router.push('/plano-acao/listar')" icon="pi pi-home" iconPos="left" type="button" class="mr-7" />
                </div>
            </div>
        </router-view>
    </div>
</template>

<script>
import PlanoAcaoService from '../../services/planoAcaoService';
import PlanoAcaoAcompanhamentoService from '../../services/planoAcaoAcompanhamentoService';
import Atualizacoes from './components/atualizacoes.vue';
import Comentarios from './components/comentarios.vue';

export default {
    data() {
        return {
            planoAcao: {},
            listaAtualizacoes: [],
            listaComentarios: [],
            items: [
                {
                    label: 'Plano Ação',
                    to: `/plano-acao/${this.$route.params.id || 'criar'}`
                },
                {
                    label: 'Acompanhamento',
                    to: `/plano-acao/${this.$route.params.id}/acompanhamento`
                },
                {
                    label: 'Anexos',
                    to: `/plano-acao/${this.$route.params.id}/anexos`
                },
                {
                    label: 'Conclusão',
                    to: `/plano-acao/${this.$route.params.id}/conclusao`
                }
            ]
        };
    },

    components: { Atualizacoes, Comentarios },

    mounted() {
        this.getData();
    },

    methods: {
        async getData() {
            this.$service = new PlanoAcaoAcompanhamentoService();

            const responsePlanoAcao = await new PlanoAcaoService().get('', '', this.$route.params.id);
            const responseLista = await this.$service.getByPlan(this.$route.params.id);

            this.planoAcao = responsePlanoAcao.data;
            this.listaAtualizacoes = responseLista.data.filter((element) => element.tipoAtualizacao === 'ACOMPANHAMENTO');
            this.listaComentarios = responseLista.data.filter((element) => element.tipoAtualizacao === 'COMENTARIO');
        }
    }
};
</script>
<style scoped>
.message {
    width: 452px;
}
.pi-home,
.pi-angle-right {
    font-size: 2rem;
}

.PENDENTE {
    background-color: #f7ffc6;
    color: #504d05;
}

.EM_ANDAMENTO {
    background-color: #c3f3f6;
    color: #0d0540;
}

.CONCLUIDO {
    background-color: #c3f6d9;
    color: #0e4005;
}

.EXCLUIDO {
    background-color: #ffd3d3;
    color: #700d06;
}
</style>
